import { Component, OnInit } from '@angular/core';
import { CartUpdateService } from '../Services/cartUpdate.service';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  itemsCount: number = 0;
  subscription: any;

  constructor(
    private cartItemsCookieService: CartItemsCookieService,
    private cartUpdateService: CartUpdateService
  ) { }

  ngOnInit() {
    console.log('on init ')

    // subscribe to changes
    this.subscription = this.cartUpdateService.getCartChangeEmitter().subscribe(() => {
      console.log('subscription')
      this.setUpdatedItemsIdsCountFromCookieService();
    });

    this.setUpdatedItemsIdsCountFromCookieService();
  }

  setUpdatedItemsIdsCountFromCookieService(){
    var addedItems = this.cartItemsCookieService.getItemIdsFromCartCookie();
    this.itemsCount = new Set(addedItems).size;
    console.log('setting updated count: ', this.itemsCount)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/cart/cart.component.ts